var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { loadingSpinnerActions } from '../actions/loadingSpinnerActions';
var initialState = {
    visible: false,
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    console.log('TYPEEE', action.type);
    switch (action.type) {
        case loadingSpinnerActions.SHOW_SPINNER_MODAL:
            return __assign(__assign({}, state), { visible: true });
        case loadingSpinnerActions.HIDE_SPINNER_MODAL:
            return __assign(__assign({}, state), { visible: false });
    }
    return state;
};
export default reducer;



//////////////////
// WEBPACK FOOTER
// ./src/reducers/loadingSpinnerReducer.ts
// module id = 632
// module chunks = 0